
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1051","height":"765","viewBox":"0 0 1051 765","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":"0.2","d":"M604.547 46.6566C927.916 212.956 1244.55 724.725 902.121 587.487C730.839 518.841 700.973 783.103 518.323 763.082C373.199 747.174 339.355 726.363 194.209 709.64C-32.1905 683.555 -23.7758 484.165 38.4644 331.649C124.658 120.437 326.933 -96.1124 604.547 46.6566Z","fill":"url(#paint0_linear_3311_35021)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_3311_35021","x1":"255.615","y1":"599.427","x2":"801.608","y2":"-22.9383","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#006DB6"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFB7A6","stop-opacity":"0.5"}})])])])
          )
        }
      }
    